/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const LineDotRightHorizontal = [
  ["path", { d: "M 3 12 L 15 12" }],
  ["circle", { cx: "18", cy: "12", r: "3" }]
];

export { LineDotRightHorizontal as default };
//# sourceMappingURL=line-dot-right-horizontal.js.map
